import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentCustomForm } from './cms-component-custom-form.interface';

export const CMS_COMPONENT_CUSTOM_FORM_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentCustomForm.ID,
    name: 'Custom form',
    description: 'Custom form from Landofcoders Magento plugin',
    tags: ['form', 'custom'],
    isAdvanced: true,
    fields: [
        {
            key: 'form_identifier',
            type: NICmsContentField.EFieldType.text,
            title: 'Form Identifier'
        },
        {
            key: 'newsletter_source',
            type: NICmsContentField.EFieldType.text,
            title: 'Newsletter Source'
        }
    ]
};
